module.exports = __webpack_public_path__ + "static/media/expand-blue.0ac3d506.svg";